import React from 'react'
import { Layout } from './Layout'
import { useProps, Params } from './useProps'

export const GameSelectModal = (params: Params) => {
  return <Layout {...useProps(params)} />
}
